module.exports = {"helmetTitle":"Veloe - Editar Dados Pessoais","title":"Dados pessoais","subtitle":"Aqui você pode editar suas informações para deixar a gente sempre atualizado. :)","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","rechargeButtonLabel":"Fazer recarga","warningModalTitle":"Aviso pra você ;)","warningModalSubtitle":"Fique atento","warningModalDisclaimer":"*Veículos com mais de 6 eixos não poderão exceder 20km/h ou inferior se previsto.","warningModalConfirm":"Ok"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/DashboardResume/data.json
// module id = 1919
// module chunks = 0